export default {
  expenseDocuments: [],
  expenseDocument: undefined,
};
